import React, { useState, useRef, useEffect } from 'react';
import TextInput from '../../../../../Components/TextInput';
import DateInput from '../../../../../Components/DateInput';
import search from '../../../../../Assets/Icons/search.png';
import Dropdown from '../../../../../Components/Dropdown';
import InvoiceReportsController from '../../../../Controllers/AdminScreens/Invoices/Reports/InvoiceReportsController';
import Loader from '../../../../../Components/Loader';

const InvoiceReportsScreen = () => {
    const {
        reportName, handleReportName, invoiceReportOptions,
        startDate, setStartDate, startDateError, handleStartDateChange,
        endDate, setEndDate, endDateError, handleEndDateChange,
        generateReportSuccess, generateReportError, generateReportLoading,
        handleSearchClient, clientListLoading, clientSearchError, clientList,
        clientError, handleSearchInputChange, handleSelectedClient,
        searchClient, handleGenerateReport, resetFilter, reportNameError,
        groupClient, setGroupClient, requiresClientGroup,
        groupClientOptionsList, groupLoading, groupClientError
    } = InvoiceReportsController()

    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const dropdownRefs = useRef({}); // Ref for dropdown

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] === null || dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div style={{ width: '93%', margin: 'auto' }}>
                <h3 style={styles.headerTop}>
                    <div style={styles.headerContainer} >
                        {/* <img
              src={backIcon}
              alt="Back"
              style={{ width: '25px', height: '25px', cursor: 'pointer', marginRight: '10px' }}
              onClick={handleBack}
            /> */}
                        <span>Invoicing Reports</span>
                    </div>
                </h3>
            </div>
            <div className="tasksScreen-main-content" style={{ width: 'unset' }}>
                <div className="tasksScreen-tasks-container" >
                    <div className="tasksScreen-tasks-header">
                        <h2 className="tasksScreen-tasks-title">Generate Reports</h2>
                    </div>
                    <hr className="footer-divider" />
                    <div style={{ width: '220px' }}>
                        <Dropdown
                            ref={(el) => (dropdownRefs.current["Report Name"] = el)}
                            isOpen={openDropdown === "Report Name"}
                            toggleDropdown={() => toggleDropdown("Report Name")}
                            label="Report Name"
                            options={invoiceReportOptions}
                            value={reportName}
                            onChange={handleReportName}
                            searchBoxWidth={200}
                            errorMessage={reportNameError}
                        />
                    </div>

                    {requiresClientGroup && (
                        <>
                            <div className="filter-field" style={{ paddingBottom: '10px', marginTop: '10px', marginBottom: '5px', width: '300px' }}>
                                <label style={{ fontSize: '12px', color: '#343C44' }}>Client Name</label>
                                <TextInput
                                    type="text"
                                    placeholder="Client Name"
                                    value={searchClient}
                                    onChange={(e) => handleSearchInputChange(e.target.value)}
                                    onRightClick={handleSearchClient}
                                    // searchBoxWidth={280}
                                    right={
                                        clientListLoading ? (
                                            <Loader loading={clientListLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                                        ) : (
                                            <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                                        )
                                    }
                                    style={{ padding: '20px 10px' }}
                                    errorMessage={clientError || clientSearchError}
                                    isEdit={!groupClient}
                                />
                                {clientList?.length > 0 && (
                                    <ul style={styles.dropdownList}>
                                        {clientList?.map((employee, index) => (
                                            <li
                                                key={employee?.client_id}
                                                onClick={() => handleSelectedClient(employee)}
                                                style={{
                                                    ...styles.dropdownItem,
                                                    borderBottom: index !== clientList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                                }}
                                            >
                                                {employee?.client_name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>

                            <div style={{ maxWidth: '300px' }}>
                                <Dropdown
                                    ref={(el) => (dropdownRefs.current["groupNameid"] = el)}
                                    isOpen={openDropdown === "groupNameid"}
                                    toggleDropdown={() => toggleDropdown("groupNameid")}
                                    label="Group Name" options={groupClientOptionsList || []}
                                    isClear={true}
                                    value={groupClient} onChange={setGroupClient} errorMessage={groupClientError}
                                    loading={groupLoading} searchBoxWidth={280}
                                    disabled={searchClient}
                                />
                            </div>
                        </>
                    )}
                    <div style={{ marginTop: '10px' }}>
                        <div className="filter-field">
                            <label>Period</label>
                            <div style={{ display: 'flex', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                                <div style={{ }}>
                                    <DateInput
                                        value={startDate || ""}
                                        onChange={(e) => handleStartDateChange(e.target.value)}
                                        errorMessage={startDateError}
                                        max={reportName?.value !== 'estimate_register_report' ? new Date().toLocaleDateString("en-CA") : undefined}
                                    />
                                </div>
                                <><div style={{ padding: '0 10px', lineHeight: '47px' }}>-</div>
                                <div style={{ }}>
                                    <DateInput
                                        value={endDate || ""}
                                        onChange={(e) => handleEndDateChange(e.target.value)}
                                        errorMessage={endDateError}
                                        max={reportName?.value !== 'estimate_register_report' ? new Date().toLocaleDateString("en-CA") : undefined}
                                    />
                                </div></>
                            </div>

                        </div>
                    </div>
                    <div className="button-container" style={{ gap: "10px" }}>
                        <button className="add-client-button" onClick={() => handleGenerateReport(reportName)}
                            style={{
                                cursor: generateReportLoading ? "not-allowed" : "pointer",
                                opacity: generateReportLoading ? 0.6 : 1,
                                pointerEvents: generateReportLoading ? 'none' : 'auto',
                                gap: '5px',
                                display: 'flex'
                            }}
                            disabled={generateReportLoading}>

                            {generateReportLoading && (
                                <Loader loading={generateReportLoading} color={'var(--background-color)'} size="small" />
                            )}
                            <span>Generate</span>
                        </button>
                        <button style={{ ...styles.cancelButton, paddingLeft: '30px', paddingRight: '30px' }} onClick={resetFilter}>
                            Cancel
                        </button>
                        {generateReportError && <div style={{ fontSize: '12px', color: 'red', display: 'flex', alignItems: 'center' }}>{generateReportError} </div>}
                        {generateReportSuccess && <div style={{ fontSize: '12px', color: 'green', display: 'flex', alignItems: 'center' }}>{generateReportSuccess} </div>}
                    </div>
                </div>
            </div>
        </>
    );
};

const styles = {
    header: {
        fontSize: "22px",
        color: "#060606",
        marginBottom: "10px",
        fontWeight: 500,
        // fontFamily: 'Montserrat',
        //   marginLeft:'20px'
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center', // Vertically align items
    },
    cancelButton: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px solid var(--button-bg-color)",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    },
    labaleStyle: {
        fontSize: '12px',
        // marginBottom: '5px',
        fontWeight: '400',
        fontFamily: 'Roboto',
        color: 'rgb(52, 60, 68)'
    },
    categoryHeader: {
        color: '#1F384C',
        fontSize: 28,
        fontFamily: 'Roboto Slab',
        fontWeight: 500,
        // paddingBottom: 20
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center', // Vertically align items
    },
    headerTop: {
        fontSize: "22px",
        color: "#060606",
        marginBottom: "10px",
        fontWeight: 500,
        // fontFamily: 'Montserrat',
        //   marginLeft:'20px'
    },
    dropdownList: {
        position: 'absolute',
        top: '85%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        padding: 0, // Remove default padding
        margin: 0, // Remove default margin
        listStyleType: 'none', // Remove the dots
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee', // Default for all items
        backgroundColor: '#fff',
        hover: {
            backgroundColor: '#f0f0f0',
        },
    },
};

export default InvoiceReportsScreen;
